export default __webpack_public_path__ + "static/media/microscope.c79ef77d.png";